<template>
	<article class="w-full">
		<div class="flex items-center">
			<div class="grow">
				<div class="space-x-2">
					<span class="font-semibold text-text-primary">
						{{ notification.metadata.message }}
					</span>
					<span>
						{{ formatDate(notification.createdAt) }}
					</span>
				</div>
				<p v-if="notification.metadata.description">
					<span class="text-text-secondary">
						{{ " " + notification.metadata.description }}
					</span>
				</p>
			</div>
			<div class="flex-none">
				<!-- slot for displaying a button on the right side -->
				<slot name="button" />
			</div>
		</div>
	</article>
</template>

<script setup lang="ts">
import type { Notification } from "@/generatedApi";
import { formatDate } from "@/helpers/uiHelpers";

interface Props {
	notification: Notification;
}
defineProps<Props>();
</script>
